import AssetsBaseSource from 'src/services/geoJson/sources/AssetsBaseSource';

export default class AssetsSource extends AssetsBaseSource {
  /** @type {String} */
  static id = 'assets';
}
